import * as CL from '@design-system/component-library';
import type { ReactNode } from 'react';

export interface GridProps {
  children: ReactNode;
  colWidthL?: CL.GridColProps['colWidthL'];
  className?: string;
  justifyCenter?: boolean;
  gutter?: boolean;
}

export const Grid = ({ children, colWidthL = 12, className, justifyCenter = true, gutter = true }: GridProps) => {
  return (
    <CL.Grid className={className}>
      <CL.GridRow justifyCenter={justifyCenter} gutter={gutter}>
        <CL.GridCol colWidthXS={4} colWidthS={6} colWidthL={colWidthL}>
          {children}
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  );
};

export const GridNarrow = ({ children }: GridProps) => <Grid colWidthL={8}>{children}</Grid>;
